// extracted by mini-css-extract-plugin
module.exports = {"Input":"input_Input__3kueO","Label":"input_Label__4hkuu","InputElement":"input_InputElement__29ZMH","Invalid":"input_Invalid__2jHNH"};